import { createContext, useContext, useEffect, useState } from "react";
import { api, tokenStore, formatErr } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, object = authed
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = tokenStore.get();
    if (!t) { setUser(false); setLoading(false); return; }
    api.get("/admin/me")
      .then((r) => setUser(r.data))
      .catch(() => { tokenStore.clear(); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    try {
      const r = await api.post("/admin/login", { email, password });
      tokenStore.set(r.data.access_token);
      setUser(r.data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatErr(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => { tokenStore.clear(); setUser(false); };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
